module.exports = __webpack_public_path__ + "static/media/ic-daji.8c9629d5.svg";